export const APP_NAME = 'Djodjo';
export const APP_TAGLINE = 'Financement participatif de confiance pour le Togo et sa diaspora';
export const APP_SHORT_DESCRIPTION =
  'Soutenez des campagnes solidaires, des événements et des projets entrepreneuriaux avec Mobile Money et carte bancaire.';

export const SUPPORT_EMAIL = 'contact@djodjo.tg';
export const SUPPORT_PHONE = null;
export const SUPPORT_CITY = 'Lomé, Togo';

export const PAYMENT_PROVIDER = 'PayDunya';
export const PAYMENT_METHODS = ['Flooz', 'TMoney', 'Carte bancaire'];
export const PAYMENT_METHODS_LABEL = 'Flooz, TMoney et carte bancaire';

export const TRUST_PROMISES = [
  'Paiement via PayDunya',
  'Modération des campagnes',
  'KYC progressif avant retrait',
];
